<template>
  <svg viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.16406 1.53516L8.47656 0.828125C8.44922 0.796875 8.40625 0.78125 8.36719 0.78125C8.32422 0.78125 8.28515 0.796875 8.25781 0.828125L3.49219 5.62891L1.75781 3.89453C1.72656 3.86328 1.6875 3.84766 1.64844 3.84766C1.60937 3.84766 1.57031 3.86328 1.53906 3.89453L0.84375 4.58984C0.78125 4.65234 0.78125 4.75 0.84375 4.8125L3.03125 7C3.17187 7.14062 3.34375 7.22266 3.48828 7.22266C3.69531 7.22266 3.875 7.07031 3.94141 7.00781H3.94531L9.16797 1.75781C9.22266 1.69141 9.22266 1.59375 9.16406 1.53516V1.53516Z"
      class="fill-current"
    />
  </svg>
</template>
